// extracted by mini-css-extract-plugin
var _1 = "Block-vPeuX";
var _2 = "BottomSpacing-GMuCF";
var _3 = "ContentVisibilityAuto-xfTPA";
var _4 = "TopSpacing-N9V6D";
export { _1 as "Block", _2 as "BottomSpacing", _3 as "ContentVisibilityAuto", _4 as "TopSpacing" }
